import styled from "@emotion/styled";
import { Divider, Image, Timeline } from "antd";
import { FC, useEffect } from "react";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";

const breadArr = [
	{
		title: "关于我们",
	},
	{
		title: "欧皮特里程碑",
	},
];

export const Histroy: FC = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<Container>
			<ImageFill src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/vhs-assets-css-21463021cd10d16695381184f646e421.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>欧皮特里程碑</h1>
				</div>
				<Bread value={breadArr} />
				<div style={{ marginBottom: "3rem" }}>
					<h2>Optibelt 自 1872 年成立以来一直致力于稳定发展、独立运营和品质。</h2>
					Optibelt 为世界各地的客户提供先进的传动解决方案。Optibelt 一直致力于提供最先进的技术和质量。目前，Optibelt 已推出第五代产品：
				</div>
				<Timeline mode='alternate' reverse={true}>
					<Timeline.Item position={"right"} dot={<div className='dotYear'>1872</div>}>
						<div style={{ position: "relative" }}>
							<div className='label right'>
								<div>
									<h5>成立 Höxterschen Gummifädenfabrik</h5>
								</div>
								<div className='line'>
									<Divider className='dividerLine'></Divider>
								</div>
							</div>
							<div className='imgRight'>
								<Image src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-historie-emil-arntz.jpg' preview={false} />
							</div>
						</div>
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item position={"left"} dot={<div className='dotYear'>1948</div>}>
						<div>
							<div className='label left'>
								<div className='line'>
									<Divider className='dividerLine'></Divider>
								</div>
								<div>
									<h5>生产首批 V 带</h5>
								</div>
							</div>
							<div className='img imgLeft'>
								<Image src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-historie-ersten-keilriemen.jpg' preview={false} />
							</div>
						</div>
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} position='right' label='1959'>
					Arnulf Ummen 执掌公司
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} position='right' label='1965'>
					开发 S=C，并进一步升级为 S=C Plus
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item position={"right"} dot={<div className='dotYear'>1975</div>}>
						<div style={{ position: "relative" }}>
							<div className='label right'>
								<div>
									<h5>更名为 Arntz Optibelt KG</h5>
								</div>
								<div className='line'>
									<Divider className='dividerLine'></Divider>
								</div>
							</div>
							<div className='img imgRight'>
								<Image src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-historie-1975.jpg' preview={false} />
							</div>
						</div>
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='1985'>
					生产 M=S Set Constant 切割式 V 带
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='1990'>
					拓展国际市场
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='1991'>
					在爱尔兰生产聚氨酯同步带
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />}>生产适合 HTD 和 RPP 皮带轮的 OMEGA 同步带</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item position={"right"} dot={<div className='bigDot' />} label='1997'>
					开始生产高效橡胶同步带
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item position={"right"} dot={<div className='bigDot' />} label='1998'>
						建立……
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item position={"left"} dot={<div className='dotYear'>2000</div>}>
						<div>
							<div className='label left'>
								<div className='line'>
									<Divider className='dividerLine'></Divider>
								</div>
								<div>
									<h5>RED POWER：首款免维护皮带</h5>
								</div>
							</div>
							<div className='img imgLeft'>
								<Image src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-historie-red-power3.jpg' preview={false} />
							</div>
						</div>
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2003'>
					生产成品聚氨酯同步带
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2007'>
						在中国建立生产基地
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2008'>
					罗马尼亚生产基地开工生产
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item position={"right"} dot={<div className='dotYear'>2012</div>}>
						<div style={{ position: "relative" }}>
							<div className='label right'>
								<div>
									<h5>新总经理上任</h5>
								</div>
								<div className='line'>
									<Divider className='dividerLine'></Divider>
								</div>
							</div>
							<div className='img imgLeft'>
								<Image src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-historie-fuehrungswechsel.jpg' preview={false} />
							</div>
						</div>
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2015'>
					在市场上推出高效碳纤维同步带
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2015'>
					开始生产特殊皮带轮和部件
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item position={"left"} dot={<div className='dotYear'>2015</div>}>
						<div>
							<div className='label left'>
								<div className='line'>
									<Divider className='dividerLine'></Divider>
								</div>
								<div>
									<h5>全球爱因斯坦活动</h5>
								</div>
							</div>
						</div>
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2016'>
					在新的中央测试中心举行奠基仪式
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2017'>
					哥伦比亚 Arntz Optibelt 新仓库落成
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='bigDot' />} label='2018'>
					SUPER XE-POWER PRO：高效，适用于小轮径
					</Timeline.Item>
					<Timeline.Item dot={<div className='blueDot' />} />
					<Timeline.Item dot={<div className='blueDot' />} />
				</Timeline>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		z-index: 10;
		position: relative;
	}

	.dotYear {
		width: 3rem;
		height: 3rem;
		text-align: center;
		line-height: 3rem;
		border-radius: 3rem;
		background-color: #004885;
		color: #fff;
		margin: 0 1rem;
	}

	.blueDot {
		background-color: #4778a3;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 0.5rem;
	}

	.bigDot {
		background-color: #004885;
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 0.8rem;
	}

	.ant-timeline-item-content {
		padding: 0 1rem;
	}

	.label {
		display: flex;
		justify-content: left;

		.line {
			width: 6rem;
			height: 1rem;

			.ant-divider-horizontal {
				margin: 1rem 2rem 1rem 0;
			}
		}

		h5 {
			line-height: 2rem;
		}
	}

	.right {
		justify-content: right;
	}

	.dividerLine {
		background-color: #004885;
	}

	.ant-timeline-item-head-blue {
		border: none;
	}

	.ant-timeline-item-content {
		.img {
			position: absolute;
			top: 2rem;
		}

		.imgLeft {
			margin-left: 6rem;
		}

		.imgRight {
			margin-right: 6rem;
		}
	}
`;
